export default __webpack_public_path__ + "static/media/_LOGO SHARDEUM BLANCO.bc2f6c73.svg";